import React, { useState, useEffect } from "react";
import { navLinks } from "../data/mockData";
import { LayoutGrid, Menu, X } from "lucide-react";

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#050505]/80 backdrop-blur-2xl border-b border-white/[0.06]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1200px] mx-auto px-6 h-[72px] flex items-center justify-between">
        {/* Logo */}
        <a href="/" className="flex items-center gap-2.5 shrink-0 group">
          <div className="w-8 h-8 rounded-lg bg-white flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
            <LayoutGrid size={16} className="text-black" />
          </div>
          <span className="text-white font-semibold text-[1.15rem] tracking-tight">AllSave</span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="text-[13px] text-[#8a8a8a] hover:text-white transition-colors duration-200 tracking-wide"
            >
              {link.name}
            </a>
          ))}
        </div>

        {/* CTA */}
        <div className="hidden lg:flex items-center gap-5">
          <a href="/login" className="text-[13px] text-[#8a8a8a] hover:text-white transition-colors duration-200">
            Sign in
          </a>
          <a
            href="/login"
            className="text-[13px] font-medium bg-white text-black rounded-full px-5 py-2.5 transition-all duration-300 hover:bg-white/90 hover:shadow-[0_0_20px_rgba(255,255,255,0.15)]"
          >
            Start for free
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="lg:hidden text-white/70 p-2 hover:text-white transition-colors"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-[#0a0a0a]/95 backdrop-blur-xl border-t border-white/[0.06] px-6 py-8 space-y-6">
          {navLinks.map((link) => (
            <a
              key={link.name}
              href={link.href}
              className="block text-sm text-[#8a8a8a] hover:text-white transition-colors py-1"
              onClick={() => setMobileOpen(false)}
            >
              {link.name}
            </a>
          ))}
          <div className="pt-4 border-t border-white/[0.06] space-y-4">
            <a href="#signin" className="block text-sm text-[#8a8a8a] hover:text-white">Sign in</a>
            <a href="#signup" className="inline-block text-sm font-medium bg-white text-black rounded-full px-5 py-2.5">
              Start for free
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
